import { genesisIcons } from '@formkit/icons'
import { defineFormKitConfig, createInput } from '@formkit/vue'
import { createProPlugin, autocomplete, unit,
  colorpicker,
  datepicker,
  dropdown,
  mask,
  rating,
  repeater,
  slider,
  taglist,
  toggle,
  togglebuttons,
  transferlist,
  currency } from '@formkit/pro'
import { pt } from '@formkit/i18n'
import { createMultiStepPlugin, createAutoHeightTextareaPlugin } from '@formkit/addons'
import { rootClasses } from '~/assets/css/formkit.theme'
import { FormSignaturePad, FormPicturePad, FormEditorPad } from '#components'

const proPlugin = createProPlugin('fk-3cea4316ba', {
  unit,
  autocomplete,
  colorpicker,
  datepicker,
  dropdown,
  mask,
  rating,
  repeater,
  slider,
  taglist,
  toggle,
  togglebuttons,
  transferlist,
  currency
  // any other Pro Inputs
})
/**
 * Set initial values to empty strings instead of undefined
 **/
// function defaultToEmptyString(node) {
//   node.hook.input((value, next) => {
//     if (value === undefined || value === null)
//       return next(node.props.type === 'mask' ? ' ' : null)
//     return next(value)
//   })
// }
/**
 * A little plugin that automatically scrolls to the first error.
 **/
function scrollToErrors(node) {
  if (node.props.type === 'form') {
    function scrollTo(node) {
      const el = document.getElementById(node.props.id)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
      }
    }

    function scrollToErrors() {
      node.walk((child) => {
        // Check if this child has errors
        if (child.ledger.value('blocking') || child.ledger.value('errors')) {
          // We found an input with validation errors
          scrollTo(child)
          // Stop searching
          return false
        }
      }, true)
    }

    const onSubmitInvalid = node.props.onSubmitInvalid
    node.props.onSubmitInvalid = () => {
      if (onSubmitInvalid)
        onSubmitInvalid(node)
      scrollToErrors()
    }
    node.on('unsettled:errors', scrollToErrors)
  }
  return false
}

/**
 * Workaround para formkit/formkit#1667: o nó raiz do form nunca é removido
 * do Set `nodes` do rootConfig ao desmontar, vazando toda a subárvore a cada
 * troca de rota. Removemos manualmente quando o nó raiz é destruído.
 * OBS: usa a API interna não documentada `rootConfig._rm`; revalidar em upgrades.
 */
function cleanupRootConfig(node: any) {
  if (!node.parent) {
    node.on('destroying', () => {
      node.config?.rootConfig?._rm?.(node)
    })
  }
  return false
}

/**
 * Workaround para bug do FormKit Pro 0.130.0 no autocomplete single-select:
 * Quando o usuário clica num item da lista, Wt() seta option e chama e.input()
 * de forma assíncrona (setTimeout). O click no documento fecha o dropdown no
 * mesmo task, antes de selections ser atualizado. O listener t(e) de prop:expanded
 * lê selections[0].label com selections ainda vazio → TypeError.
 * Solução: ao setar prop:option (síncrono), zera inputText para que inputStd.length===0
 * quando t(e) rodar, forçando o branch seguro (limpa inputText/searchValue).
 * O label correto é restaurado no próximo tick via prop:selections.
 */
function fixAutocompletePropExpandedCrash(node) {
  if (node.props.type !== 'autocomplete' || node.props.multiple) return false
  node.on('prop:option', ({ payload: option }) => {
    if (option && !node.props.selections?.length) {
      node.props.inputText = ''
    }
  })
  return false
}

export default defineFormKitConfig(() => ({
  plugins: [proPlugin, scrollToErrors, cleanupRootConfig, fixAutocompletePropExpandedCrash, createMultiStepPlugin(), createAutoHeightTextareaPlugin()],
  icons: { ...genesisIcons },
  locales: { pt },
  locale: 'pt',
  config: { rootClasses },
  inputs: {
    signPad: createInput(FormSignaturePad),
    pictPad: createInput(FormPicturePad),
    editPad: createInput(FormEditorPad)
  }
}))
